// Trip catalog for the /viajes hub.
// Each trip is tagged with a single region and one or more experiences,
// powering the interactive explorer with combined filters.

export const REGIONS = [
  {
    id: "south",
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=2000&q=85",
    accent: "#C16542",
    label:    { es: "Sur de Marruecos",      en: "South of Morocco",   fr: "Sud du Maroc" },
    tagline:  { es: "Dunas, kasbahs y palmerales", en: "Dunes, kasbahs and palm groves", fr: "Dunes, kasbahs et palmeraies" },
    body:     { es: "El reino del desierto. Erg Chebbi, Erg Chigaga, valle del Drâa y las puertas del Sáhara.",
                en: "Kingdom of the desert. Erg Chebbi, Erg Chigaga, Drâa Valley and the gateways of the Sahara.",
                fr: "Le royaume du désert. Erg Chebbi, Erg Chigaga, vallée du Drâa et portes du Sahara." },
    routeId: "tourSouth",
  },
  {
    id: "north",
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=2000&q=85",
    accent: "#3A4A5F",
    label:    { es: "Norte de Marruecos",    en: "North of Morocco",   fr: "Nord du Maroc" },
    tagline:  { es: "Ciudades azules y medinas históricas", en: "Blue towns and historic medinas", fr: "Villes bleues et médinas historiques" },
    body:     { es: "Chefchaouen, Tánger, Tetuán y las playas del Rif — un Marruecos mediterráneo, fresco y cinematográfico.",
                en: "Chefchaouen, Tangier, Tetouan and the Rif beaches — a fresh, cinematic, Mediterranean Morocco.",
                fr: "Chefchaouen, Tanger, Tétouan et les plages du Rif — un Maroc méditerranéen, frais et cinématographique." },
    routeId: "tourNorth",
  },
  {
    id: "all",
    image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=2000&q=85",
    accent: "#A07042",
    label:    { es: "Marruecos de norte a sur", en: "Morocco from north to south", fr: "Le Maroc du nord au sud" },
    tagline:  { es: "El recorrido completo del país", en: "The full sweep of the country", fr: "La traversée complète du pays" },
    body:     { es: "Ciudades imperiales, costas atlánticas, desiertos infinitos y aldeas de montaña remotas — el recorrido completo del país.",
                en: "Imperial cities, Atlantic coastlines, endless desert and remote mountain villages — the full sweep of the country.",
                fr: "Cités impériales, côtes atlantiques, déserts infinis et villages de montagne reculés — la traversée complète du pays." },
    routeId: "tourFull",
  },
];

export const EXPERIENCES = [
  {
    id: "desert",
    icon: "Sparkles",
    accent: "#C16542",
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1600&q=85",
    label:   { es: "Aventuras en el desierto", en: "Desert adventures",     fr: "Aventures dans le désert" },
    blurb:   { es: "Caravanas de camellos, bivouacs bajo las estrellas y noches de fuego en el Sáhara.",
               en: "Camel caravans, bivouacs under the stars and firelit nights in the Sahara.",
               fr: "Caravanes de chameaux, bivouacs sous les étoiles et nuits au coin du feu au Sahara." },
  },
  {
    id: "cultural",
    icon: "BookOpen",
    accent: "#A07042",
    image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1600&q=85",
    label:   { es: "Escapadas culturales", en: "Cultural escapes",         fr: "Escapades culturelles" },
    blurb:   { es: "Medinas antiguas, riads de familia, talleres de artesanos y cenas en azoteas.",
               en: "Ancient medinas, family riads, artisan workshops and rooftop dinners.",
               fr: "Médinas anciennes, riads de famille, ateliers d'artisans et dîners en terrasse." },
  },
  {
    id: "trekking",
    icon: "Mountain",
    accent: "#5A6B4F",
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1600&q=85",
    label:   { es: "Trekking y aventura", en: "Trekking & adventure",      fr: "Trekking & aventure" },
    blurb:   { es: "Toubkal, valle de Aït Bouguemez, enduro por las dunas y rutas 4x4 por el Anti-Atlas.",
               en: "Toubkal, Aït Bouguemez valley, enduro across the dunes and 4x4 routes through the Anti-Atlas.",
               fr: "Toubkal, vallée d'Aït Bouguemez, enduro sur les dunes et circuits 4x4 dans l'Anti-Atlas." },
  },
  {
    id: "private",
    icon: "Crown",
    accent: "#D4A373",
    image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1600&q=85",
    label:   { es: "Viajes privados", en: "Private tours",                 fr: "Voyages privés" },
    blurb:   { es: "Itinerarios diseñados exclusivamente para ti, con chófer-guía y acceso a lugares fuera de los circuitos habituales.",
               en: "Itineraries designed exclusively for you, with private driver-guide and access to places off the usual circuits.",
               fr: "Itinéraires conçus exclusivement pour vous, avec chauffeur-guide et accès à des lieux hors des circuits habituels." },
  },
  {
    id: "group",
    icon: "Users",
    accent: "#3A4A5F",
    image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1600&q=85",
    label:   { es: "Salidas en grupo", en: "Group departures",             fr: "Départs en groupe" },
    blurb:   { es: "Circuitos con fechas programadas para Semana Santa, verano, fin de año y ocasiones especiales.",
               en: "Tours with scheduled dates for Easter, summer, New Year and special occasions.",
               fr: "Circuits à dates programmées pour Pâques, l'été, le Nouvel An et grandes occasions." },
  },
  {
    id: "wellness",
    icon: "Leaf",
    accent: "#5F8A82",
    image: "https://images.unsplash.com/photo-1489493585363-d69421e0edd3?auto=format&fit=crop&w=1600&q=85",
    label:   { es: "Bienestar y desconexión", en: "Wellness & disconnection", fr: "Bien-être & déconnexion" },
    blurb:   { es: "Experiencias para reconectar contigo mismo entre oasis, kasbahs, paisajes infinitos y ritmos pausados.",
               en: "Experiences to reconnect with yourself among oases, kasbahs, endless landscapes and unhurried rhythms.",
               fr: "Des expériences pour se reconnecter à soi-même entre oasis, kasbahs, paysages infinis et rythmes paisibles." },
  },
];

// Sample catalog — 12 trips tagged for the interactive explorer.
export const TRIPS = [
  {
    id: "sahara-soul",
    region: "south",
    experiences: ["desert", "cultural", "group"],
    duration: { es: "7 noches", en: "7 nights", fr: "7 nuits" },
    from: 2890,
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1600&q=85",
    title:   { es: "Alma del Sáhara",          en: "Sahara Soul",            fr: "L'âme du Sahara" },
    summary: { es: "De Dadès a Erg Chebbi: caravana de camellos, bivouac berebere y noches bajo la Vía Láctea.",
               en: "From Dadès to Erg Chebbi: camel caravan, Berber bivouac and Milky-Way nights.",
               fr: "De Dadès à Erg Chebbi : caravane de chameaux, bivouac berbère et nuits sous la Voie lactée." },
  },
  {
    id: "atlas-villages",
    region: "south",
    experiences: ["trekking", "cultural", "private"],
    duration: { es: "9 noches", en: "9 nights", fr: "9 nuits" },
    from: 3450,
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1600&q=85",
    title:   { es: "Aldeas bereberes del Atlas", en: "Atlas Berber villages", fr: "Villages berbères de l'Atlas" },
    summary: { es: "Senderismo entre kasbahs de pisé, cenas en familias Aït Atta y noches en gîtes de piedra.",
               en: "Hiking between earthen kasbahs, dinners with Aït Atta families and stone-gîte nights.",
               fr: "Randonnée entre kasbahs en pisé, dîners chez les familles Aït Atta et nuits en gîte." },
  },
  {
    id: "imperial-cities",
    region: "all",
    experiences: ["cultural", "private", "wellness"],
    duration: { es: "10 noches", en: "10 nights", fr: "10 nuits" },
    from: 4250,
    image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1600&q=85",
    title:   { es: "Ciudades imperiales & riads", en: "Imperial cities & riads", fr: "Cités impériales & riads" },
    summary: { es: "Fez, Meknès, Salé y Marrakech con cuatro maestros artesanos y cuatro riads privados.",
               en: "Fez, Meknès, Salé and Marrakech with four master artisans and four private riads.",
               fr: "Fès, Meknès, Salé et Marrakech avec quatre maîtres artisans et quatre riads privés." },
  },
  {
    id: "blue-pearl",
    region: "north",
    experiences: ["cultural"],
    duration: { es: "5 noches", en: "5 nights", fr: "5 nuits" },
    from: 1980,
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1600&q=85",
    title:   { es: "Perla azul del Rif",       en: "Blue Pearl of the Rif",  fr: "Perle bleue du Rif" },
    summary: { es: "Chefchaouen, fromagers del Rif y la última familia de tintoreros de índigo de la medina.",
               en: "Chefchaouen, Rif cheese-makers and the last indigo dyers of the medina.",
               fr: "Chefchaouen, fromagers du Rif et la dernière famille de teinturiers d'indigo." },
  },
  {
    id: "atlantic-wind",
    region: "north",
    experiences: ["cultural", "private", "wellness"],
    duration: { es: "6 noches", en: "6 nights", fr: "6 nuits" },
    from: 2380,
    image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1600&q=85",
    title:   { es: "Viento atlántico & argán", en: "Atlantic wind & argan",  fr: "Vents atlantiques & argan" },
    summary: { es: "Essaouira, Sidi Kaouki y Oualidia. Surf al amanecer y cooperativas de mujeres amazigh.",
               en: "Essaouira, Sidi Kaouki and Oualidia. Dawn surf and women's amazigh cooperatives.",
               fr: "Essaouira, Sidi Kaouki et Oualidia. Surf à l'aube et coopératives de femmes amazighes." },
  },
  {
    id: "enduro-sahara",
    routeId: "tourAventuraEnduroHub",
    region: "south",
    experiences: ["trekking", "desert", "group"],
    duration: { es: "3 o 4 noches", en: "3 or 4 nights", fr: "3 ou 4 nuits" },
    image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1600&q=85",
    title:   { es: "Enduro Sáhara",            en: "Sahara enduro",          fr: "Enduro Sahara" },
    summary: { es: "Dos programas de 3 o 4 noches con 2 o 3 días de moto con guía por Tisserdimine, Erg Chebbi y Merzouga.",
               en: "Two programmes of 3 or 4 nights with 2 or 3 guided riding days through Tisserdimine, Erg Chebbi and Merzouga.",
               fr: "Deux programmes de 3 ou 4 nuits avec 2 ou 3 jours de moto avec guide par Tisserdimine, Erg Chebbi et Merzouga." },
  },
  {
    id: "toubkal-summit",
    region: "south",
    experiences: ["trekking"],
    duration: { es: "5 días", en: "5 days", fr: "5 jours" },
    from: 1690,
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1600&q=85",
    title:   { es: "Cumbre del Toubkal",       en: "Toubkal summit",         fr: "Sommet du Toubkal" },
    summary: { es: "Ascensión a 4.167 m con guías locales certificados. Apto para senderistas con buena forma.",
               en: "Ascent to 4,167 m with certified local guides. Suited to fit hikers.",
               fr: "Ascension à 4 167 m avec guides locaux certifiés. Pour randonneurs en bonne forme." },
  },
  {
    id: "honeymoon",
    region: "south",
    experiences: ["private", "cultural", "desert", "wellness"],
    duration: { es: "8 noches", en: "8 nights", fr: "8 nuits" },
    from: 5680,
    image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1600&q=85",
    title:   { es: "Luna de miel mágica",      en: "Honeymoon magic",        fr: "Lune de miel magique" },
    summary: { es: "Riad con jardín privado, cena bajo cedros del Atlas y noche en tienda caïdal a luz de velas.",
               en: "Riad with private garden, dinner under Atlas cedars and a candle-lit caïdal tent.",
               fr: "Riad avec jardin privé, dîner sous les cèdres et nuit en tente caïdale aux chandelles." },
  },
  {
    id: "north-mosaic",
    region: "north",
    experiences: ["cultural", "group"],
    duration: { es: "7 noches", en: "7 nights", fr: "7 nuits" },
    from: 2590,
    image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1600&q=85",
    title:   { es: "Mosaico del Norte",        en: "Northern mosaic",        fr: "Mosaïque du Nord" },
    summary: { es: "Tánger, Volúbilis, Mequinez y Fez. Mosaicos romanos, medinas vivas y café en la kasbah.",
               en: "Tangier, Volubilis, Meknès and Fez. Roman mosaics, living medinas and kasbah coffee.",
               fr: "Tanger, Volubilis, Meknès et Fès. Mosaïques romaines, médinas vivantes et café à la kasbah." },
  },
  {
    id: "short-essential",
    region: "all",
    experiences: ["cultural"],
    duration: { es: "4 noches", en: "4 nights", fr: "4 nuits" },
    from: 1190,
    image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1600&q=85",
    title:   { es: "Esencial de 4 noches",     en: "Essential 4-night",      fr: "Essentiel 4 nuits" },
    summary: { es: "Marrakech + bivouac en el desierto + Aït Benhaddou. Marruecos concentrado en lo esencial.",
               en: "Marrakech + desert bivouac + Aït Benhaddou. Morocco distilled.",
               fr: "Marrakech + bivouac au désert + Aït Benhaddou. Le Maroc concentré." },
  },
  {
    id: "easter-departure",
    region: "south",
    experiences: ["group", "desert", "cultural"],
    duration: { es: "Semana Santa", en: "Easter week", fr: "Semaine de Pâques" },
    from: 1850,
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1600&q=85",
    title:   { es: "Salida Semana Santa 2026", en: "Easter 2026 departure",  fr: "Départ Pâques 2026" },
    summary: { es: "Fechas cerradas: 28 Mar — 04 Abr. Grupo reducido. Bivouac en Erg Chigaga.",
               en: "Fixed dates: 28 Mar — 04 Apr. Small group. Erg Chigaga bivouac.",
               fr: "Dates fixes : 28 mars — 4 avril. Petit groupe. Bivouac à Erg Chigaga." },
  },
  {
    id: "anti-atlas-4x4",
    region: "south",
    experiences: ["trekking", "private", "desert"],
    duration: { es: "6 días", en: "6 days", fr: "6 jours" },
    from: 2790,
    image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1600&q=85",
    title:   { es: "4x4 Anti-Atlas",           en: "4x4 Anti-Atlas",         fr: "4x4 Anti-Atlas" },
    summary: { es: "Expedición todoterreno por pistas perdidas, oasis dormidos y palmerales secretos.",
               en: "Off-road expedition across forgotten tracks, sleeping oases and secret palm groves.",
               fr: "Expédition tout-terrain sur des pistes oubliées, oasis et palmeraies secrètes." },
  },
];
